var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},_vm._l((_vm.categories),function(category){return _c('el-button',{key:category.value,attrs:{"plain":""},on:{"click":function($event){return _vm.handleClick(category)}}},[_c('svgicon',{attrs:{"name":'sport/football/match/' + category.icon,"original":""}}),_vm._v("\n    "+_vm._s(category.label)+"\n  ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }